import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6.85 15q.776 0 1.388-.45t.862-1.175l.375-1.15q.4-1.2-.2-2.213Q8.675 9 7.55 9H4.025l.475 3.925q.125.875.787 1.475.663.6 1.563.6m10.3 0q.9 0 1.563-.6t.787-1.475L19.975 9h-3.5q-1.125 0-1.725 1.025t-.2 2.225l.35 1.125q.25.725.862 1.175.613.45 1.388.45m-10.3 2q-1.65 0-2.887-1.088a4.2 4.2 0 0 1-1.438-2.737L2 9a.97.97 0 0 1-.712-.287A.97.97 0 0 1 1 8a.97.97 0 0 1 .288-.713A.97.97 0 0 1 2 7h5.55q1.1 0 2.013.537A3.9 3.9 0 0 1 11 9h2.025q.525-.925 1.438-1.463A3.9 3.9 0 0 1 16.474 7H22a.97.97 0 0 1 .712.287Q23 7.575 23 8c0 .425-.096.52-.288.713A.97.97 0 0 1 22 9l-.525 4.175a4.2 4.2 0 0 1-1.438 2.737A4.24 4.24 0 0 1 17.15 17q-1.425 0-2.562-.813A4.23 4.23 0 0 1 13 14.026l-.375-1.125-.1-.363a5 5 0 0 1-.1-.537h-.85a5 5 0 0 1-.1.488l-.1.362L11 14a4.3 4.3 0 0 1-1.588 2.175A4.26 4.26 0 0 1 6.85 17" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }